import React, { useState } from 'react';
import { agregarEmpresa } from '../services/empresasService';

export default function AgregarEmpresa({ onEmpresaAgregada }) {
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: '',
    direccion: '',
    contacto_nombre: '',
    contacto_email: '',
    contacto_telefono: '',
    rfc: '',
    razon_social: '',
    direccion_fiscal: '',
  });

  const [mensaje, setMensaje] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Construye objeto con campos requeridos
      const nuevaEmpresa = {
        ...formData,
        activo: true, // valor por defecto
      };

      const empresaGuardada = await agregarEmpresa(nuevaEmpresa);

      setMensaje('✅ Empresa agregada exitosamente!');
      setFormData({
        nombre: '',
        descripcion: '',
        direccion: '',
        contacto_nombre: '',
        contacto_email: '',
        contacto_telefono: '',
        rfc: '',
        razon_social: '',
        direccion_fiscal: '',
      });

      if (onEmpresaAgregada) {
        onEmpresaAgregada(empresaGuardada);
      }
    } catch (error) {
      console.error(error);
      setMensaje('❌ Error al agregar la empresa.');
    }
  };

  return (
    <div className="max-w-xl mx-auto p-4 border rounded shadow">
      <h2 className="text-xl font-bold mb-2">Agregar Empresa</h2>
      <form onSubmit={handleSubmit} className="space-y-3">

        <div>
          <label className="block font-medium">Nombre:</label>
          <input
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            required
            className="border px-2 py-1 w-full rounded"
          />
        </div>

        <div>
          <label className="block font-medium">Descripción:</label>
          <textarea
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className="border px-2 py-1 w-full rounded"
          />
        </div>

        <div>
          <label className="block font-medium">Dirección:</label>
          <input
            type="text"
            name="direccion"
            value={formData.direccion}
            onChange={handleChange}
            className="border px-2 py-1 w-full rounded"
          />
        </div>

        <div>
          <label className="block font-medium">Contacto Nombre:</label>
          <input
            type="text"
            name="contacto_nombre"
            value={formData.contacto_nombre}
            onChange={handleChange}
            className="border px-2 py-1 w-full rounded"
          />
        </div>

        <div>
          <label className="block font-medium">Contacto Email:</label>
          <input
            type="email"
            name="contacto_email"
            value={formData.contacto_email}
            onChange={handleChange}
            className="border px-2 py-1 w-full rounded"
          />
        </div>

        <div>
          <label className="block font-medium">Contacto Teléfono:</label>
          <input
            type="text"
            name="contacto_telefono"
            value={formData.contacto_telefono}
            onChange={handleChange}
            className="border px-2 py-1 w-full rounded"
          />
        </div>

        <div>
          <label className="block font-medium">RFC:</label>
          <input
            type="text"
            name="rfc"
            value={formData.rfc}
            onChange={handleChange}
            className="border px-2 py-1 w-full rounded"
          />
        </div>

        <div>
          <label className="block font-medium">Razón Social:</label>
          <input
            type="text"
            name="razon_social"
            value={formData.razon_social}
            onChange={handleChange}
            className="border px-2 py-1 w-full rounded"
          />
        </div>

        <div>
          <label className="block font-medium">Dirección Fiscal:</label>
          <input
            type="text"
            name="direccion_fiscal"
            value={formData.direccion_fiscal}
            onChange={handleChange}
            className="border px-2 py-1 w-full rounded"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Guardar
        </button>
      </form>

      {mensaje && <p className="mt-2 text-sm">{mensaje}</p>}
    </div>
  );
}